var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateGoldenmetrics',{attrs:{"title":_vm.$t('menu.dashboard'),"categories":_vm.categories,"route":_vm.$listRoutes.dashboardGoldenmetrics}})
}
var staticRenderFns = []

export { render, staticRenderFns }